import React, { useEffect, useState } from 'react'
import SaveButton from '../../../buttons/SaveButton';
import { ToastContainer, toast } from 'react-toastify';
import { Form } from 'react-bootstrap';
import { versionListTodo } from '../../../../redux/slices/master/version/VersionDetails';
import { updateVersionTodo } from '../../../../redux/slices/master/version/UpdateVersion';
import { useDispatch, useSelector } from 'react-redux';
import { useFormik } from 'formik';
import Loader from '../../../loader/Loader';
import Text from '../../../input_filed/Text';
import { UpdateVersionSchema } from './Validation';
import { useNavigate } from 'react-router-dom';

export default function UpdateVersionForm() {

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const [bool, setBool] = useState(false)
    const [spiner, setSpiner] = useState(false)
    const version = useSelector(state => state?.versionList?.data?.data)
    // console.log(version)

    let initialValues = {
        type: "",
        andriod_id: version?.[0]?._id,
        ios_id: version?.[1]?._id,
        andriod_version: version?.[0]?.version,
        ios_version: version?.[1]?.version
    }

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: UpdateVersionSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setLoading(true)
            dispatch(updateVersionTodo(values)).then((res) => updateVersion_res(res))
        },
    })

    const updateVersion_res = (res) => {
        // console.log("Update Version Response:", res?.payload);
        const payload = res?.payload;
        const androidStatus = payload?.android?.status;
        const iosStatus = payload?.ios?.status;
        const globalStatus = payload?.status;
        const androidMessage = payload?.android?.message;
        const iosMessage = payload?.ios?.message;
        const globalMessage = payload?.message;

        if ((androidStatus && iosStatus) || globalStatus === true) {
            toast.success(androidMessage || iosMessage || globalMessage || "Version updated successfully", {
                position: "bottom-right",
            });
            setBool(!bool)
            setLoading(false);

        }
        else if (payload?.status === 401) {
            toast.error("Session expired. Please login again.", { position: "bottom-right" });
            localStorage.clear();
            navigate("/login");
            setSpiner(false);

        }
        else if (payload?.status === 400) {
            toast.error("400 Bad Request", { position: "bottom-right" });
            setSpiner(false);

        }
        else if (payload?.status === 404) {
            toast.error("404 Not Found", { position: "bottom-right" });
            setSpiner(false);

        }
        else {
            toast.error(globalMessage || androidMessage || iosMessage || "Version update failed", {
                position: "bottom-right",
            });
            setLoading(false);
        }
    };


    useEffect(() => {
        setLoading(true)
        dispatch(versionListTodo()).then((res) => versionList_Res(res?.payload))
    }, [bool])

    const versionList_Res = (res) => {
        if (res && res.success) {
            setLoading(false)
            initialValues.andriod_version = res && res.data && res.data[0] && res.data[0].version
            initialValues.ios_version = res && res.data && res.data[1] && res.data[1].version
        } else {
            setLoading(false)
        }
    }
    return (
        <>


            <div className='main_layout p-3'>
                <div className='layout_head mb-3'>
                    <h5>Update Version</h5>
                </div>
                <hr />
                {loading ?
                    <div className='d-flex justify-content-center '>
                        <Loader />
                    </div> :
                    <div className='row'>
                        <div className='col-md-12'>
                            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                                <div className=' mt-2'>

                                    <div className='row'>
                                        <div className='col-md-4'>
                                            <Text
                                                name='andriod_version'
                                                label_name={version?.[0]?.type}
                                                value={values.andriod_version}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.andriod_version && touched.andriod_version ? (<span className='text-danger form_label' >{errors.andriod_version}</span>) : null}
                                            />
                                        </div>
                                        <div className='col-md-4'>
                                            <Text
                                                name='ios_version'
                                                label_name={version?.[1]?.type}
                                                value={values.ios_version}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={errors.ios_version && touched.ios_version ? (<span className='text-danger form_label' >{errors.ios_version}</span>) : null}
                                            />
                                        </div>

                                        <div className='col-md-12 text-end mt-2'>
                                            <SaveButton name={'UPDATE'} spiner={spiner} />
                                        </div>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                }
            </div>


        </>
    )
}
